






















































/* General */
import Vue from 'vue'
import moment from 'moment'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'
import { DueTypeValues } from '@/types'

/* API */

export default Vue.extend({
  name: 'IfpFilterDue',
  props: {
    selectedDueType: {
      type: Number,
      default: null,
    },
    startDueDate: {
      type: String,
      default: '',
    },
    endDueDate: {
      type: String,
      default: '',
    },
    dueDateOptions: {
      type: Array as () => IItemForSelection[],
      required: true,
    },
  },
  data() {
    return {
      dueDateOpen: false,
      calendarValue: [],
      dateFormat: 'MMMM DD, YYYY',
      dateFormatDisplay: 'MMMM dd, yyyy',
      dateRange: [],
      readyToSelectDueDateRange: false, // Clicking "In date range..." but haven't selected range yet...
    }
  },
  computed: {
    filteredDueDateOptions(): IItemForSelection[] {
      if (this.$screen.isMobile(this.$mq)) {
        return this.dueDateOptions.filter(d => !this.isDueDateRangeOption(d.id))
      }
      return this.dueDateOptions
    },
    isDueDateRangeOptionSelected(): boolean {
      return this.isDueDateRangeOption(this.selectedDueType)
    },
    showCalendar(): boolean {
      return this.isDueDateRangeOptionSelected || this.readyToSelectDueDateRange
    },
    selectedDueDateLabel(): string {
      if (
        this.isDueDateRangeOptionSelected &&
        this.startDueDate &&
        this.endDueDate
      ) {
        return this.formattedDateRange()
      } else {
        const selDueDate = this.dueDateOptions.find(
          dueDate => dueDate.id === this.selectedDueType,
        )
        return selDueDate ? selDueDate.name : ''
      }
    },
  },

  watch: {
    dueDateOpen: {
      handler(value) {
        if (!value) {
          // If "In date range..." selected but user opts out...
          this.readyToSelectDueDateRange = false
        }
      },
    },
    startDueDate: {
      immediate: true,
      handler(value) {
        this.calendarValue = [
          this.startDueDate ? moment(this.startDueDate) : moment(),
          this.endDueDate ? moment(this.endDueDate) : moment(),
        ]

        const dateStart = moment(this.calendarValue[0])
        const dateEnd = moment(this.calendarValue[1])

        this.dateRange.push(dateStart.format(this.dateFormat))
        this.dateRange.push(dateEnd.format(this.dateFormat))
      },
    },
  },

  methods: {
    isDueDateRangeOption(id: number): boolean {
      return id === DueTypeValues.DATE_RANGE
    },
    /**
     * Helper function that returns date to show on select with correct date format
     */
    formattedDateRange(): string {
      const dateRange = this.dateRange
      const startDateObj = moment(dateRange[0], this.dateFormat)
      const startDate = startDateObj.format(this.getFormattedDate(dateRange[0]))
      const endDateObj = moment(dateRange[1], this.dateFormat)
      const endDate = endDateObj.format(this.getFormattedDate(dateRange[1]))
      if (startDate !== endDate) {
        return `${startDate}-${endDate}`
      } else {
        return `${startDate}`
      }
    },
    getFormattedDate(value: string): string {
      const currentDate = moment(new Date())
      return moment(value).isSame(currentDate, 'year') ? 'MMM D' : 'MMM D, YYYY'
    },
    handleSelectedRange(newValue: any) {
      // Without this, this method is re-invoked when going from "In date range..."
      // to another due type.
      if (!this.showCalendar) {
        return
      }
      this.dateRange = [...newValue]

      const dateRange = newValue.map((value: any, index: number) => {
        return moment(newValue[index]).format('YYYY-MM-DD')
      })

      this.updateSelectedDuetype(DueTypeValues.DATE_RANGE)

      if (this.startDueDate !== dateRange[0]) {
        this.updateStartDueDate(dateRange[0])
      }
      if (this.endDueDate !== dateRange[1]) {
        this.updateEndDueDate(dateRange[1])
      }

      this.closeDueDateDropdown()
    },
    handleDueTypeClick(val: number) {
      if (this.isDueDateRangeOption(val)) {
        this.readyToSelectDueDateRange = true
      } else {
        this.updateSelectedDuetype(val)
        this.readyToSelectDueDateRange = false
        this.closeDueDateDropdown()
        this.dateRange = []
        this.updateStartDueDate(null)
        this.updateEndDueDate(null)
      }
    },
    closeDueDateDropdown() {
      if (this.$refs.dueDateDropdown) {
        // @ts-ignore
        this.$refs.dueDateDropdown.handleClose()
      }
    },
    updateSelectedDuetype(val: number) {
      this.$emit('selected-due-type-updated', val)
    },
    updateStartDueDate(val: any) {
      this.$emit('start-due-date-updated', val)
    },
    updateEndDueDate(val: any) {
      this.$emit('end-due-date-updated', val)
    },
    handleClearClick() {
      this.handleDueTypeClick(null)
    },
  },
})
